import {
  ElementRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AssetClassSummary } from '@models/asset-class.interface';

@Component({
  selector: 'app-asset-class-list',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule],
  templateUrl: './asset-class-list.component.html',
  styleUrl: './asset-class-list.component.scss'
})
export class AssetClassListComponent implements OnChanges {
  private readonly hostElement = inject(ElementRef<HTMLElement>);

  @Input() assetClasses: AssetClassSummary[] = [];
  @Input() selectedId: number | null = null;
  @Input() newlyCreatedId: number | null = null;

  @Output() assetClassSelected = new EventEmitter<AssetClassSummary>();
  @Output() addClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<number>();

  readonly displayedColumns = ['name', 'alias', 'actions'];

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['selectedId'] && !changes['assetClasses']) return;

    setTimeout(() => this.scrollToSelectedRow());
  }

  onRowClick(assetClass: AssetClassSummary): void {
    this.assetClassSelected.emit(assetClass);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onDeleteClick(assetClass: AssetClassSummary, event: Event): void {
    event.stopPropagation();
    this.deleteClicked.emit(assetClass.id);
  }

  private scrollToSelectedRow(): void {
    if (this.selectedId === null) return;

    const row = this.hostElement.nativeElement.querySelector(
      `tr[data-asset-class-id="${this.selectedId}"]`
    ) as HTMLElement | null;

    row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}